// @generated by protoc-gen-connect-query v0.4.1
// @generated from file admin/v1/identities.proto (package admin.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { createQueryService } from "@bufbuild/connect-query";
import { MethodKind } from "@bufbuild/protobuf";
import { CreateUserRequest, CreateUserResponse, DeleteExternalIdMappingRequest, DeleteExternalIdMappingResponse, DeleteUserRequest, DeleteUserResponse, GetMachineUserAuthTokenRequest, GetMachineUserAuthTokenResponse, GetUserByIdRequest, GetUserByIdResponse, GetUserExternalIdsRequest, GetUserExternalIdsResponse, ListUsersRequest, ListUsersResponse, MapUserToExternalIdRequest, MapUserToExternalIdResponse, RefreshMachineUserAuthTokenRequest, RefreshMachineUserAuthTokenResponse, UpdateUserRequest, UpdateUserResponse } from "@buf/formal_admin.bufbuild_es/admin/v1/identities_pb.js";

export const typeName = "admin.v1.UserService";

/**
 * @generated from rpc admin.v1.UserService.ListUsers
 */
export const listUsers = createQueryService({
  service: {
    methods: {
      listUsers: {
        name: "ListUsers",
        kind: MethodKind.Unary,
        I: ListUsersRequest,
        O: ListUsersResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).listUsers;

/**
 * @generated from rpc admin.v1.UserService.CreateUser
 */
export const createUser = createQueryService({
  service: {
    methods: {
      createUser: {
        name: "CreateUser",
        kind: MethodKind.Unary,
        I: CreateUserRequest,
        O: CreateUserResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).createUser;

/**
 * @generated from rpc admin.v1.UserService.GetUserById
 */
export const getUserById = createQueryService({
  service: {
    methods: {
      getUserById: {
        name: "GetUserById",
        kind: MethodKind.Unary,
        I: GetUserByIdRequest,
        O: GetUserByIdResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).getUserById;

/**
 * @generated from rpc admin.v1.UserService.DeleteUser
 */
export const deleteUser = createQueryService({
  service: {
    methods: {
      deleteUser: {
        name: "DeleteUser",
        kind: MethodKind.Unary,
        I: DeleteUserRequest,
        O: DeleteUserResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).deleteUser;

/**
 * @generated from rpc admin.v1.UserService.UpdateUser
 */
export const updateUser = createQueryService({
  service: {
    methods: {
      updateUser: {
        name: "UpdateUser",
        kind: MethodKind.Unary,
        I: UpdateUserRequest,
        O: UpdateUserResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).updateUser;

/**
 * @generated from rpc admin.v1.UserService.GetMachineUserAuthToken
 */
export const getMachineUserAuthToken = createQueryService({
  service: {
    methods: {
      getMachineUserAuthToken: {
        name: "GetMachineUserAuthToken",
        kind: MethodKind.Unary,
        I: GetMachineUserAuthTokenRequest,
        O: GetMachineUserAuthTokenResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).getMachineUserAuthToken;

/**
 * @generated from rpc admin.v1.UserService.RefreshMachineUserAuthToken
 */
export const refreshMachineUserAuthToken = createQueryService({
  service: {
    methods: {
      refreshMachineUserAuthToken: {
        name: "RefreshMachineUserAuthToken",
        kind: MethodKind.Unary,
        I: RefreshMachineUserAuthTokenRequest,
        O: RefreshMachineUserAuthTokenResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).refreshMachineUserAuthToken;

/**
 * @generated from rpc admin.v1.UserService.GetUserExternalIds
 */
export const getUserExternalIds = createQueryService({
  service: {
    methods: {
      getUserExternalIds: {
        name: "GetUserExternalIds",
        kind: MethodKind.Unary,
        I: GetUserExternalIdsRequest,
        O: GetUserExternalIdsResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).getUserExternalIds;

/**
 * @generated from rpc admin.v1.UserService.MapUserToExternalId
 */
export const mapUserToExternalId = createQueryService({
  service: {
    methods: {
      mapUserToExternalId: {
        name: "MapUserToExternalId",
        kind: MethodKind.Unary,
        I: MapUserToExternalIdRequest,
        O: MapUserToExternalIdResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).mapUserToExternalId;

/**
 * @generated from rpc admin.v1.UserService.DeleteExternalIdMapping
 */
export const deleteExternalIdMapping = createQueryService({
  service: {
    methods: {
      deleteExternalIdMapping: {
        name: "DeleteExternalIdMapping",
        kind: MethodKind.Unary,
        I: DeleteExternalIdMappingRequest,
        O: DeleteExternalIdMappingResponse,
      },
    },
    typeName: "admin.v1.UserService",
  },
}).deleteExternalIdMapping;
